import { Gizmo } from "flowy-3-core";
import { Row } from "antd";
import { comemosTodos } from "../../assets/images";

type LoginHeaderProps = {
  gizmo: Gizmo;
};

const LoginHeader = ({ gizmo }: LoginHeaderProps) => {
  return (
    <Row justify={"center"}>
      <img
        src={comemosTodos}
        alt=""
        style={{
          maxWidth: "100%",
        }}
      />
    </Row>
  );
};

export default LoginHeader;
